
<template>
  <div class="app-background">
    <Navbar />
    <main class="main-content">
      <h1>Govori Brani~evo</h1>
      <img src="@/assets/grb.png" alt="Center Image" class="center-image" />
    </main>
  </div>
</template>

<script setup>
import Navbar from './components/NavbarA.vue'
</script>

<style>

.app-background {
  background-image: url('../src/assets/pozadina.jpg'); /* Replace with your actual background image path */
  background-size: cover;
  background-repeat: no-repeat;
  background-position:center;
  min-height: 100vh;
}


.main-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 60px); /* Adjust if your Navbar has a fixed height */
  padding: 2rem;
  color: white;
  text-align: center;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
}

/* Centered image styling */
.center-image {
  max-width: 600px;
  width: 100%;
  height: auto;
  margin-bottom: 1rem;
}

body {
  margin: 0;
  font-family: sans-serif;
}

</style>



